import * as React from "react";
import * as ReactDOM from "react-dom";

export const Portal = ({ children, container }) => {
  return ReactDOM.createPortal(children, container);
};
